import { Translation } from 'cng-common/features/translations'

import { TMarketYoyGrowthExpectationWorkflowState, TMarketYoyGrowthViewType } from '../../api/types'
import { MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS } from '../../configs/translations'

import styles from './MarketYoyGrowthExpectationHeader.module.scss'

const KEYS = MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS

const STATE_VARIANT: Record<TMarketYoyGrowthExpectationWorkflowState, string> = {
  draft: 'neutral',
  published: 'success',
  locked: 'danger',
}

interface IMarketYoyGrowthExpectationHeaderProps {
  workflowState?: TMarketYoyGrowthExpectationWorkflowState | null
  viewType: TMarketYoyGrowthViewType
  marketName: string
}

export const MarketYoyGrowthExpectationHeader = ({
  workflowState,
  viewType,
  marketName,
}: IMarketYoyGrowthExpectationHeaderProps) => {
  return (
    <div className={styles.header}>
      <div className={styles.titleRow}>
        <div className={styles.title}>
          <Translation text={KEYS.title} />
        </div>
        {workflowState && (
          <div className={`${styles.state} ${styles[`state--${STATE_VARIANT[workflowState]}`]}`}>
            {workflowState}
          </div>
        )}
        <div className={`${styles.state} ${styles['state--info']}`}>
          {viewType === 'Market' ? marketName : viewType}
        </div>
      </div>

      <div className={styles.subtitle}>
        <Translation text={KEYS.subtitle} />
      </div>
    </div>
  )
}

MarketYoyGrowthExpectationHeader.displayName = 'MarketYoyGrowthExpectationHeader'
